import {APIService} from "../../common/APIService";
import {QuoteRequest} from "../../dto/QuoteRequest";

export class QuoteRequestService extends APIService {
  public async browse(): Promise<QuoteRequest[]> {
    const json = await this.getJson<{ data: object[] }>(`quote-requests`)
    return json.data.map(item => QuoteRequest.fromJson(item));
  }

  /** Marks the quote request as handled; the server sets `handled_at` to the current time. */
  public async edit(quoteRequestId: string): Promise<QuoteRequest> {
    const json = await this.putJson<{ data: object }>(`quote-requests/${quoteRequestId}`, {})
    return QuoteRequest.fromJson(json.data)
  }
}